<span class="copy-to-clipboard"
      appInteract
      (interact)="copyToClipboard()"
      tabindex="0">
    <ng-content></ng-content>
    <div class="icon"><mat-icon>content_copy</mat-icon></div>
</span>

